import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-forgot",
	templateUrl: "./forgot.component.html",
	styleUrls: ["./forgot.component.scss"]
})
export class ForgotComponent {
	public email = "";

	public errormessage: string;
	public success = false;

	constructor(public router: Router, private api: ApiService) { }

	Forgot() {
		this.errormessage = undefined;
		this.success = false;
		this.api.ForgotPassword(this.email).then(() => {
			this.success = true;
		}).catch(err => {
			if (err && err.status && err.status === 400) {
				this.errormessage = "Email required";
			} else {
				this.errormessage = "Forgot password failed";
			}
		});
	}

}
